


























































































































































































import {
  Component,
  Provide,
  Watch,
  Ref,
  Mixins,
} from "vue-property-decorator"
import QuestionGroupPreviewItem from "./partials/QuestionGroupPreviewItem.vue"
import QuestionGroupPreviewCandidateProfile from "./partials/QuestionGroupPreviewCandidateProfile.vue"
import QuestionGroupPreviewRiskProfile from "./partials/QuestionGroupPreviewRiskProfile.vue"
import QuestionGroupPreviewQuestionGroup from "./partials/QuestionGroupPreviewQuestionGroup.vue"
import { mapState } from "vuex"
import { NEGATIVE_RULE_FLAGS } from "@/constants/questionnaire_answer"
import QuestionMixins from "@/mixins/QuestionMixins"
import QQuestionnaireResultLayout from "@/components/Questionnaire/QQuestionnaireResultLayout.vue"
import BookingReport from "@/pages/Admin/Booking/BookingReport.vue"
import QQuestionAnswer from "@/components/QQuestionAnswer.vue"

@Component({
  components: {
    QuestionGroupPreviewItem,
    QuestionGroupPreviewCandidateProfile,
    QuestionGroupPreviewRiskProfile,
    QuestionGroupPreviewQuestionGroup,
    QQuestionnaireResultLayout,
    BookingReport,
    QQuestionAnswer
  },
  computed: {
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup",
    }),
    ...mapState("QuestionnaireAnswer", {
      questionnaireAnswer: "questionnaireAnswer",
      questionnaire: "questionnaire",
    }),
    ...mapState("CandidateProfile", {
      candidateProfile: "candidateProfile",
      candidateProfileQuestionGroups: "questionGroups",
    }),
    ...mapState("RiskProfile", {
      riskProfile: "riskProfile",
    }),
  },
})
export default class QuestionGroupPreview extends Mixins(QuestionMixins) {
  @Ref("questionGroupPreview")
  questionGroupPreview!: QuestionGroupPreviewQuestionGroup

  questionGroup!: Model
  questionnaireAnswer!: Model
  questionnaire!: Model
  candidateProfile!: Model
  candidateProfileQuestionGroups!: Model[]
  riskProfile!: Model

  slot = "qg-preview"
  activeIndex = 0
  isMounted = false
  isEnd = false
  reloadWindow = false
  isRiskProfileSelected = false
  isCandidateProfileSelected = false
  startQuestion = false
  showResultDialog = false

  negativeRuleFlags = NEGATIVE_RULE_FLAGS

  questionGroupQuestions = []
  questionIndex = 0

  @Provide() isPreview = true

  @Watch("riskProfile", { immediate: true })
  watchRiskProfile(newVal) {
    // Report component fetches the risk profile and will trigger the risk profile changes in the vuex, so we have to stop
    // the watcher if the report is showing
    if (this.showResultDialog) {
      return
    }

    this.isRiskProfileSelected = !!newVal.object_id

    if (this.isRiskProfileSelected && this.isCandidateProfileSelected) {
      this.startPreview()
    }
  }

  @Watch("candidateProfile", { immediate: true })
  watchCandidateProfile(newVal) {
    this.isCandidateProfileSelected = newVal && newVal.object_id

    if (this.isRiskProfileSelected && this.isCandidateProfileSelected) {
      this.startPreview()
    }
  }

  @Watch("slot", { immediate: true })
  watchSlot(newVal) {
    if (newVal == "qg-preview") {
      this.startQuestion =
        !!this.questionnaireAnswer?.object_id ||
        (this.candidateProfile?.object_id &&
          this.candidateProfile.is_for_question_group_preview)
    } else {
      this.startQuestion = false
    }
  }

  get isResultReady() {
    if (this.questionGroup.is_for_candidate_profile) {
      return !this.candidateProfile || !this.candidateProfile.object_id
    }

    return !this.questionnaireAnswer || !this.questionnaireAnswer.object_id
  }

  get questionGroups() {
    if (this.questionGroup.is_for_candidate_profile) {
      return this.candidateProfileQuestionGroups
    }
    return this.questionnaire?.question_groups ?? [this.questionGroup]
  }

  get questionGroupResult() {
    if (this.questionGroup.is_for_candidate_profile) {
      return this.candidateProfileQuestionGroups.map(
        this.$store.getters["Questionnaire/mapQuestionGroup"]
      )
    }

    return this.questionnaire.question_groups.map(
      this.$store.getters["Questionnaire/mapQuestionGroup"]
    )
  }

  beforeDestroy() {
    this.$store.commit("Questionnaire/CLEAR_STATE")
    this.$tabEvent.off("reload-preview-" + this.$route.params.questionGroupOid)
  }

  async mounted() {
    this.init()
    this.$tabEvent.on(
      "reload-preview-" + this.$route.params.questionGroupOid,
      () => {
        this.handleReset()
      }
    )
    this.isMounted = true
  }

  get candidateProfileName() {
    return this.candidateProfile
      ? this.candidateProfile.preview_name
        ? this.candidateProfile.preview_name
        : "N/A"
      : "N/A"
  }

  get riskProfileName() {
    return this.riskProfile.name ? this.riskProfile.name : "N/A"
  }

  async init() {
    this.isMounted = false
    this.$store.commit("Questionnaire/CLEAR_STATE")
    await this.$store.dispatch("QuestionGroup/fetch", {
      objectId: this.$route.params.questionGroupOid,
    })
    await this.startPreview()
    this.isMounted = true
  }

  handleReset() {
    // Cleanup the states
    this.reloadWindow = true
    this.slot = "qg-preview"
    this.$nextTick(async () => {
      this.init()
      this.reloadWindow = false
    })
  }

  async startPreview() {
    if (this.questionGroup.is_for_candidate_profile) {
      this.$store.commit("CandidateProfile/SET_IS_PREVIEW_MODE", true)
      await this.$store.dispatch(
        "QuestionGroup/previewForCandidateProfile",
        this.questionGroup.object_id
      )
      this.$store.commit("CandidateProfile/SET_QUESTION_GROUPS", [
        this.questionGroup,
      ])
      this.startQuestion = true
    } else if (this.isRiskProfileSelected && this.isCandidateProfileSelected) {
      await this.$store.dispatch("QuestionGroup/previewForStandard", {
        objectId: this.questionGroup.object_id,
        config: {
          candidate_profile_object_id: this.candidateProfile?.object_id,
          risk_profile_object_id: this.riskProfile?.object_id,
        },
      })
    }
  }

  async fetchResult() {
    if (this.questionGroup.is_for_candidate_profile) {
      await this.$store.dispatch("CandidateProfile/fetchForPreview", {
        params: {
          question_group: this.questionGroup.object_id,
        },
      })
    } else {
      await this.$store.dispatch(
        "QuestionnaireAnswer/fetchResultForPreview",
        this.questionnaireAnswer.object_id
      )
    }

    this.slot = "results"
  }

  showResult() {
    if (this.questionGroup.is_for_candidate_profile) {
      this.fetchResult()
    } else {
      this.showResultDialog = true
    }
  }

  updateSidebar(payload) {
    this.questionGroupQuestions = payload.question_group_available_questions
    this.questionIndex = payload.question_offset
  }

  activateQuestion(index) {
    this.questionGroupPreview.fetchQuestion(index)
    this.questionIndex = index
  }

  formatQuestionAnswer(question) {
    const mappedQuesiton =
      this.$store.getters["Questionnaire/mapQuestion"](question)
    return this.answerText(mappedQuesiton)
  }
}
